<template>
    <div class="im-popover">
        <template v-if="isReallyUser">
            <transition
                :name="transition"
                @after-enter="handleAfterEnter"
                @after-leave="handleAfterLeave"
            >
                <div
                    :class="['popper', popperClass]"
                    ref="popper"
                    v-show="!disabled && showPopper"
                >
                    <slot></slot>
                </div>
            </transition>
        </template>
        <div
            class="reference_wrap"
            ref="wrapper"
            @mouseleave="handleMouseLeave"
            @mouseenter="handleMouseEnter"
            v-bind:showPopper="showPopper"
        >
            <slot name="reference"></slot>
        </div>
    </div>
</template>

<script>
import popper from '../mixins/popper';
import util from '@/common/util';
export default {
    name: 'im-popper',
    mixins: [popper],
    props: {
        transition: {
            type: String,
            default: 'fade-in-linear'
        },
        hover: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        popperClass: {
            type: String,
            default: ''
        }
    },
    watch: {
        disabled(val) {
            if (val) this.showPopper = false;
        }
    },
    computed: {
        isReallyUser() {
            return util.isReallyUser;
        }
    },
    methods: {
        handleAfterEnter() {
            this.$emit('after-enter');
        },
        handleAfterLeave() {
            this.doDestroy();
            this.$emit('after-leave');
        },
        handleMouseEnter() {
            console.log('mouse enter');
            if (!this.hover) return null;
            this.showPopper = true;
        },
        handleMouseLeave() {
            if (!this.hover) return null;
            this.showPopper = false;
        },
        onClickRef(reference) {
            reference.addEventListener('click', this.toggle, false);
            this.$once('hook:beforeDestroy', () => {
                reference.removeEventListener('click', this.toggle, false);
            });
        },
        onDocumentClick() {
            window.document.addEventListener(
                'click',
                this.clickDocument,
                false
            );
            this.$once('hook:beforeDestroy', () => {
                window.document.removeEventListener(
                    'click',
                    this.clickDocument,
                    false
                );
            });
        },
        clickDocument(e) {
            let reference = (this.referenceEle =
                this.reference || this.$refs.reference);
            const popper = this.popper || this.$refs.popper;
            if (!reference && this.$refs.wrapper.children) {
                reference = this.referenceEle = this.$refs.wrapper.children[0];
            }
            if (
                !this.$el ||
                !reference ||
                this.$el.contains(e.target) ||
                reference.contains(e.target) ||
                !popper ||
                popper.contains(e.target)
            )
                return;
            this.showPopper = false;
        }
    },
    mounted() {
        let reference = (this.referenceEle =
            this.reference || this.$refs.reference);
        if (!reference && this.$refs.wrapper.children) {
            reference = this.referenceEle = this.$refs.wrapper.children[0];
        }
        this.onClickRef(reference);
        this.onDocumentClick();
        if (this.disabled) this.showPopper = false;
    }
};
</script>

<style lang="scss" scoped>
@import './transition.scss';
.popper {
    z-index: var(--level-high);
}
</style>
<style lang="scss">
.popper {
    .arrow,
    .arrow::before {
        position: absolute;
        width: 8px;
        height: 8px;
        background: inherit;
    }

    .arrow {
        visibility: hidden;
    }
    .arrow::before {
        visibility: visible;
        content: '';
        transform: rotate(45deg);
        border: 1px solid;
        border-color: inherit;
    }
}
.popper[data-popper-placement^='top'] > .arrow {
    bottom: -4px;
    border-top-color: transparent;
    border-left-color: transparent;
}

.popper[data-popper-placement^='bottom'] > .arrow {
    top: -4px;
    border-right-color: transparent;
    border-bottom-color: transparent;
}

.popper[data-popper-placement^='left'] > .arrow {
    right: -4px;
    border-left-color: transparent;
    border-bottom-color: transparent;
}

.popper[data-popper-placement^='right'] > .arrow {
    left: -4px;
    border-top-color: transparent;
    border-right-color: transparent;
}
</style>
